import type { UserAuth } from '@/types/initial-request';

export type LoginIdentifierType = 'email' | 'phone' | null;

export function normalizeLoginIdentifierType(value: unknown): LoginIdentifierType {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toLowerCase();
  if (normalized === 'email') return 'email';
  if (normalized === 'phone') return 'phone';
  return null;
}

export function resolveLoginIdentifierType({
  userAuth,
  cookieHint,
}: {
  userAuth?: Pick<UserAuth, 'email' | 'phoneNumber'> | null;
  cookieHint?: unknown;
}): LoginIdentifierType {
  const hasEmail = Boolean(userAuth?.email?.trim());
  const hasPhone = Boolean(userAuth?.phoneNumber?.trim());
  const normalizedHint = normalizeLoginIdentifierType(cookieHint);

  if (normalizedHint === 'email' && hasEmail) return 'email';
  if (normalizedHint === 'phone' && hasPhone) return 'phone';

  if (hasEmail && !hasPhone) return 'email';
  if (hasPhone && !hasEmail) return 'phone';

  if (normalizedHint && (hasEmail || hasPhone)) return normalizedHint;
  return null;
}
